import { Fragment, useRef, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { PropertyThumbnail } from "./";
import { toast } from "react-hot-toast";

import axios from "../api/axios";
import { useSelector } from "react-redux";

export default function BrokerageServiceConversionModal({
  statusChangeConfirmation,
  closeConfirmation,
  enquiryItem,
}) {
  const [open, setOpen] = useState(true);
  const state = useSelector((state) => state.UserReducer);
  const cancelButtonRef = useRef(null);
  const teamsListUrl = "/team";
  const usersByTeamUrl = "/user/team";
  const serviceTicketUrl = "/serviceticket";

  const [targetAssigneeId, setTargetAssigneeId] = useState(null);
  const [teamsServerData, setTeamsServerData] = useState([]);
  const getTeamsList = (serviceTypeId) => {
    try {
      axios
        .get(teamsListUrl + "/" + serviceTypeId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.teams?.length > 0) {
            setTeamsServerData(response.data.teams);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [teamUsersServerData, setTeamUsersServerData] = useState([]);
  const getTeamUsers = (teamId) => {
    try {
      axios
        .get(usersByTeamUrl + "/" + teamId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setTeamUsersServerData(response.data.users);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  useEffect(() => {
    getTeamsList(enquiryItem?.serviceTypeId?._id);
  }, [enquiryItem._id]);

  return (
    <Transition.Root
      show={open}
      as={Fragment}
      afterLeave={() => {
        closeConfirmation();
      }}>
      <Dialog
        as='div'
        className='relative z-[60]'
        initialFocus={cancelButtonRef}
        onClose={() => {
          setOpen(false);
        }}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'>
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed z-50 inset-0 overflow-y-auto bg-gray-200 bg-opacity-60'>
          <div className='flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
              <Dialog.Panel className='relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full'>
                <div className='bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4'>
                  <div className='sm:flex sm:items-start'>
                    <div className='mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'>
                      <ExclamationIcon
                        className='h-6 w-6 text-red-600'
                        aria-hidden='true'
                      />
                    </div>
                    <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full'>
                      <Dialog.Title
                        as='h3'
                        className='text-lg leading-6 font-medium text-yellow-2'>
                        Brokerage Service Conversion
                      </Dialog.Title>
                      <div className='mt-2 w-full'>
                        <div className='flex flex-col gap-1 w-12/12'>
                          <span className='font-semibold text-sm text-gray-700'>
                            Target Assignee
                          </span>
                          <div className='flex gap-3 w-full'>
                            <div className='mt-1 w-6/12'>
                              <select
                                className={`block py-1 px-2 w-full bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                onChange={(e) => {
                                  e.preventDefault();
                                  if (e.target.value !== "")
                                    getTeamUsers(e.target.value);
                                }}>
                                <option value=''>Select Team</option>
                                {teamsServerData.length > 0 ? (
                                  teamsServerData.map((item) => (
                                    <option key={item?._id} value={item?._id}>
                                      {item?.name}
                                    </option>
                                  ))
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </div>
                            <div className='mt-1 w-6/12'>
                              <select
                                className={`block w-full py-1 px-2 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                onChange={(e) => {
                                  e.preventDefault();
                                  if (e.target.value !== "")
                                    setTargetAssigneeId(e.target.value);
                                }}>
                                <option value=''>Select Assignee</option>
                                {teamUsersServerData.length > 0 ? (
                                  teamUsersServerData.map((item) => (
                                    <option key={item?._id} value={item?._id}>
                                      {item?.fullname
                                        ? item.fullname
                                        : item.firstname}
                                    </option>
                                  ))
                                ) : (
                                  <option key='1' value=''>
                                    Loading...
                                  </option>
                                )}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>
                  <button
                    type='button'
                    className='w-full inline-flex justify-center rounded-sm shadow-sm px-3 py-1 bg-yellow-3 text-base font-medium text-white hover:bg-yellow-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm'
                    onClick={() => {
                      statusChangeConfirmation(true, "", targetAssigneeId);
                    }}>
                    Confirm
                  </button>
                  <button
                    type='button'
                    className='mt-3 w-full inline-flex justify-center rounded-sm border border-gray-300 shadow-sm px-2 py-1 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                    onClick={() => {
                      setOpen(false);
                    }}
                    ref={cancelButtonRef}>
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
